import * as actionTypes from '../../../constants/actionTypes'

const initState = {
    data: [],
    menu: false,
    backdrop: true,
    redirect: false,
    toastMessage: '',
    loadingPage: true,
    redirectId: false,
    toastStatus: false,
    categoryDetails: {
        title: '',
        image: '',
        video: '',
        id: ''
    }
}

const commonReducer = (state = initState, action) => {
    switch (action.type) {
        case actionTypes.DATA: return { ...state, data: action.payload }
        case actionTypes.OPEN_MENU: return { ...state, menu: action.payload }
        case actionTypes.LOADING_PAGE: return { ...state, loadingPage: action.payload }
        case actionTypes.LOADING_BACKDROP: return { ...state, backdrop: action.payload }
        case actionTypes.CATEGORY_DETAILS: return { ...state, categoryDetails: action.payload }
        case actionTypes.REDIRECT: return { ...state, redirect: action.payload, redirectId: action.id || false }
        case actionTypes.SNACKBAR:
            return {
                ...state,
                toastStatus: action.payload.status,
                toastMessage: action.payload.message
            }
        default: return state
    }
}

export default commonReducer
